module.exports = __webpack_public_path__ + "static/media/Home Page_website-08.aea283b8.png";